export default __webpack_public_path__ + "static/background-image-6b121922a68014da7df05c81e7131056.svg";